const icons = {
  dashboard: "/assets/images/icons/dashboard-icon.svg",
  exterminator: "/assets/images/icons/dashboard-icon.svg",
  inventory: "/assets/images/icons/inventory-icon.svg",
  customer: "/assets/images/icons/customer-icon.svg",
  task: "/assets/images/icons/task-manage-icon.svg",
  performance: "/assets/images/icons/performance-icon.svg",
  logout: "/assets/images/icons/logout-icon.svg",
  user: "/assets/images/img/user.png",
  totalUsers: "/assets/images/icons/total-users-icon.png",
  growArrowIcon: "/assets/images/icons/grow-arrow-icon.svg",
  totalTaskIcon: "/assets/images/icons/total-task-icon.png",
  dashCubeIcon: "/assets/images/icons/dash-cube-icon.png",
  notFound: "/assets/images/icon/search-file.gif",
  doubleArrow: "/assets/images/icons/double-arrow.svg",
  calendar: "/assets/images/icons/calendar.png",
  // --
  grower: "/assets/images/icons/grower-icon.svg",
  exportCSV: "/assets/images/icons/export-csv-icon.svg",
  field: "/assets/images/icons/field-icon.svg",
  splash: "/assets/images/icons/splash-icon.png",
  addPhoto: "/assets/images/icons/add-photo-icon.svg",
  noProfile: "/assets/images/icons/no-profile-picture-15257.svg",
  dopeIcon: "/assets/images/icons/Polygon 1.svg",
  deleteIcon: "/assets/images/icons/delete-icon.svg",
  plusIcon: "/assets/images/icons/plus-icon.svg",
  attachIcon: "/assets/images/icons/attach-icon.svg",
  attachWhiteIcon: "/assets/images/icons/attach-white-icon.svg",
  pdfIcon: "/assets/images/icons/pdf-icon.png",
  privacy: "/assets/images/icons/privacy.svg",
  about: "/assets/images/icons/about.svg",
  terms: "/assets/images/icons/terms.svg",
  arrow: "/assets/images/icons/arrow.svg",
  plusIconArrow: "/assets/images/icons/greenPlusIcon.svg",
};

const logos = {
  appLogo: "/assets/images/img/logo.png",
};

const backgrounds = {
  loginBackground: "/assets/images/background/login_img.png",
};

const images = {
  graphImage: "/assets/images/img/graph.png",
  inProgress: "/assets/images/img/not-found-2.png",
};

const placeHolders = {};

const ImagesUrl = {
  ...icons,
  ...images,
  ...backgrounds,
  ...logos,
  ...placeHolders,
};

export default ImagesUrl;
